'use client'

import _ from 'lodash'
import NextLink from 'next/link'
import { usePathname } from 'next/navigation'
import { twMerge } from 'tailwind-merge'
import { researchPages } from '@/settings'

export function Nav() {
  const pathname = usePathname()

  const NavItem = ({ name, href }: { name: string; href: string }) => {
    return (
      <li key={href}>
        <NextLink prefetch={true} hrefLang='en' href={href} className={twMerge('nav-item', pathname === href && 'active')}>
          {name}
        </NextLink>
      </li>
    )
  }

  return (
    <nav className='side-nav' aria-label='Research Navigation'>
      <div id='research-nav-heading' className='pb-3 text-xl font-bold'>
        Research
      </div>
      <ul className='btn-group'>
        {_.map(researchPages, (d, idx) => (
          <NavItem key={`ip_${idx}`} {...d} />
        ))}
      </ul>
    </nav>
  )
}
